// ui/web/src/components/buzz/BuzzNavButton.tsx
import { cn } from "@/shared/lib/utils"
import { SvgBubbleText as MessageCircleIcon } from "@opal/icons"

interface BuzzNavButtonProps {
  active: boolean
  unreadCount: number
  onClick: () => void
  tooltip?: string
}

export function BuzzNavButton({ active, unreadCount, onClick, tooltip = "Buzz (⌘⇧B)" }: BuzzNavButtonProps) {
  return (
    <div className="relative">
      <button
        id="buzz-nav-btn"
        aria-label={tooltip}
        aria-pressed={active}
        title={tooltip}
        onClick={onClick}
        className={cn(
          "btn btn-ghost btn-icon relative",
          active && "bg-[var(--color-primary-subtle)] text-[var(--color-primary)]"
        )}
      >
        <MessageCircleIcon className="size-4" aria-hidden />
        {unreadCount > 0 && (
          <span
            className="absolute -top-1 -right-1 size-4 rounded-full bg-[var(--status-error-01)] text-white text-[10px] font-bold flex items-center justify-center"
            aria-label={`${unreadCount} unread messages`}
          >
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>
    </div>
  )
}
